import React, { useState } from 'react';
import { produce } from 'immer';
import { AddIcon, ChevronDownIcon, FileExcelIcon } from 'tdesign-icons-react';
import { Button, Dropdown, Link, MessagePlugin, Popconfirm, Space } from 'tdesign-react';
import { isEmpty } from 'lodash';
import { useEventEmitter } from 'ahooks';
import { deleteHost, validateHost } from '@/services/resourceService';
import PermWrapper from '@/components/PermWrapper';
import HostTable, { defaultColumns } from '../../components/HostTable';
import ImportModal from './ImportModal';
import Detail from './Detail';
import FormModal from './FormModal';

export default function Right({ clusterId }) {
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [importVisible, setImportVisible] = useState(false);
  const refreshEmmiter = useEventEmitter();

  const selectedRowKeys = selectedRowData.map((item) => item.id);

  const doRefresh = () => {
    refreshEmmiter.emit();
  };

  const options = [
    {
      content: (
        <Space size='small' align='center'>
          <AddIcon />
          新建主机
        </Space>
      ),
      value: 1,
    },
    {
      content: (
        <Space size='small' align='center'>
          <FileExcelIcon />
          导入Excel
        </Space>
      ),
      value: 2,
    },
  ];

  const columns = produce(defaultColumns, (draft) => {
    draft[1].cell = ({ row }) => <Detail detail={row} />;
    draft.push({
      colKey: 'option',
      title: '操作',
      fixed: 'right',
      align: 'center',
      cell: ({ row }) => (
        <Space>
          <PermWrapper resource='pulsar:resource:hosts:validate'>
            <Link
              theme='primary'
              onClick={() => {
                handleVerify([row.id]);
              }}
              hover='color'
            >
              验证
            </Link>
          </PermWrapper>
          <PermWrapper resource='pulsar:resource:hosts:delete'>
            <Popconfirm theme='danger' content='确定删除？' onConfirm={() => doDelete(row)}>
              <Link theme='danger' hover='color'>
                删除
              </Link>
            </Popconfirm>
          </PermWrapper>
        </Space>
      ),
      width: 150,
    });
  });

  const handleVerify = async (ids) => {
    let tip;
    try {
      tip = MessagePlugin.loading({
        content: '验证中...',
        duration: 0,
      });
      const { data } = await validateHost({
        opsHostsIdList: ids,
        opsClusterId: clusterId,
      });
      const found = find(data, { isVerified: 'NO' });
      if (found) {
        MessagePlugin.error('验证失败！');
      } else {
        MessagePlugin.success('验证通过！');
        setSelectedRowData([]);
        doRefresh();
      }
    } catch (error) {
      console.trace(error);
      throw error;
    } finally {
      MessagePlugin.close(tip);
    }
  };

  const doDelete = async ({ id }) => {
    try {
      await deleteHost(id, { opsClusterId: clusterId });
      MessagePlugin.success('删除成功');
      doRefresh();
    } catch (error) {
      console.trace(error);
      throw error;
    }
  };

  const onSelectChange = (value, { selectedRowData }) => {
    setSelectedRowData(selectedRowData);
  };

  const clickHandler = ({ value }) => {
    if (value === 1) {
      setVisible(true);
    }
    if (value === 2) {
      setImportVisible(true);
    }
  };

  const handleClose = (refresh) => {
    setVisible(false);
    setImportVisible(false);
    if (refresh) {
      doRefresh();
    }
  };

  const operators = (
    <>
      <PermWrapper resource='pulsar:resource:hosts:create'>
        <Dropdown options={options} onClick={clickHandler}>
          <Button theme='primary' suffix={<ChevronDownIcon />}>
            新建主机
          </Button>
        </Dropdown>
      </PermWrapper>

      {!isEmpty(selectedRowKeys) && (
        <PermWrapper resource='pulsar:resource:hosts:validate'>
          <Button
            disabled={isEmpty(selectedRowKeys)}
            theme='primary'
            variant='outline'
            onClick={() => handleVerify(selectedRowKeys)}
          >
            验证
          </Button>
        </PermWrapper>
      )}
    </>
  );

  const afterLoadData = (datas) => {
    setSelectedRowData([]);
    return datas;
  };

  return (
    <>
      <HostTable
        clusterId={clusterId}
        operators={operators}
        selectedRowData={selectedRowData}
        onSelectChange={onSelectChange}
        columns={columns}
        afterLoadData={afterLoadData}
        refreshEmmiter={refreshEmmiter}
      />
      <FormModal visible={visible} clusterId={clusterId} handleClose={handleClose} />
      <ImportModal clusterId={clusterId} visible={importVisible} handleClose={handleClose} />
    </>
  );
}
